<form
	class="filters d-flex align-items-center justify-content-between w-100"
	[formGroup]="filterSelection.getFormGroup()"
	(keydown.enter)="applyFilter()"
	(ngSubmit)="applyFilter()"
>
	<mat-slide-toggle
		data-test-id="toggleIsOnlyZestySupported"
		[formControlName]="commitmentFilters.is_supported"
		[color]="'primary'"
		(change)="onSupportedChange($event)"
	>
		<span>Supported by</span>
		<app-main-logo [imgClasses]="'ml-1'" [imgHeight]="31"></app-main-logo>
	</mat-slide-toggle>

	<div>
		<mat-slide-toggle
			data-test-id="toggleIsExpired"
			class="mr-4"
			[formControlName]="commitmentFilters.expired"
			[color]="'primary'"
			(change)="onExpiredChange($event)"
		>
			<span>Expired only</span>
		</mat-slide-toggle>
		<mat-slide-toggle
			data-test-id="toggleIsPurchasedWithin"
			class="mr-4"
			*ngIf="isPurchaseWithin7DaysShown"
			[formControlName]="commitmentFilters.start"
			[color]="'primary'"
			(change)="onStartChange($event)"
		>
			<span>Purchased within the last 7 days</span>
		</mat-slide-toggle>
		<mat-slide-toggle
			data-test-id="toggleIsExpiredWithin"
			[formControlName]="commitmentFilters.end"
			[color]="'primary'"
			(change)="onEndChange($event)"
		>
			<span>Expires within 12 months</span>
		</mat-slide-toggle>
	</div>
</form>
